/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BuildingType {
    RENTAL_PROPERTY = 'RENTAL_PROPERTY',
    OWN_PROPERTY = 'OWN_PROPERTY',
}
